import { render, staticRenderFns } from "./AllocationOutList.vue?vue&type=template&id=52285ca2&scoped=true"
import script from "./AllocationOutList.vue?vue&type=script&lang=js"
export * from "./AllocationOutList.vue?vue&type=script&lang=js"
import style0 from "./AllocationOutList.vue?vue&type=style&index=0&id=52285ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52285ca2",
  null
  
)

export default component.exports